export type TaskType = 'General' | 'Wild Card' | 'TBD';

export class Task {
  constructor(
    readonly ID: number,
    readonly ru: string,
    readonly en: string,
    readonly type: TaskType,
    readonly targetOfPunishment: string,
    readonly time: number | string,
    readonly used: boolean,
    readonly comments: string,
    readonly replayable: number,
    readonly wildy: boolean
  ) {
  }

  get isGeneral(): boolean {
    return this.type === 'General';
  }

  get isTime(): boolean {
    return typeof(this.time) === 'number';
  }
}
